import { render, staticRenderFns } from "./o-collected-product.vue?vue&type=template&id=fb1e4f5c&"
import script from "./o-collected-product.vue?vue&type=script&lang=js&"
export * from "./o-collected-product.vue?vue&type=script&lang=js&"
import style0 from "./o-collected-product.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports